<template>
  <v-container fluid grid-list-md v-if="boardItem">
    <AppTitleBar>
      <template v-slot:title>{{ boardItem.entity.display }}</template>
      <template slot="actions">
        <v-tooltip top transition="fade-transition">
          <template v-slot:activator="{ on }">
            <v-btn icon small @click="dismiss" v-if="board" v-on="on">
              <v-icon small>{{ $vuetify.icons.values.viewBack }}</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('labels.backTo') }} {{ board ? board.display : '' }}</span>
        </v-tooltip>
        <v-menu bottom left min-width="150" v-if="$deal.isAllowed('atLeastAdvisor')">
          <template #activator="{ on: menu }">
            <v-tooltip top transition="fade-transition">
              <template #activator="{ on: tooltip }">
                <v-btn icon small slot="activator">
                  <v-icon small v-text="$vuetify.icons.values.options" v-on="{ ...tooltip, ...menu }" />
                </v-btn>
              </template>
              <span>{{ $t('labels.actions') }}</span>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item @click="archive" v-if="$entity.isAllowed('destroy', boardItem.entity)">
              <v-list-item-title>{{ $t('labels.archive') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="destroy" v-if="$entity.isAllowed('destroy', boardItem.entity)">
              <v-list-item-title>{{ $t('labels.delete') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </AppTitleBar>

    <v-row column>
      <v-col cols="12">
        <VWidget :enable-toolbar="false">
          <template v-slot:content>
            <StateStepper
              :board-item="boardItem"
              :include="include"
              :key="`stepper-${boardItem.entity.id}`"
              :read-only="!$deal.isAllowed('atLeastAdvisor')"
              use-i18n
            />
          </template>
        </VWidget>
      </v-col>
      <v-col cols="12">
        <v-tabs v-model="activeTab" slider-color="grey darken-1">
          <v-tab ripple>{{ $t('labels.overview') }}</v-tab>
          <v-tab-item class="mt-4">
            <home-deal-overview :deal="boardItem.entity" :key="`home-overview-${boardItem.entity.id}`" />
          </v-tab-item>

          <v-tab ripple>{{ $t('labels.deal') }}</v-tab>
          <v-tab-item class="mt-4">
            <home-deal-general :deal="boardItem.entity" :key="`general-${boardItem.entity.id}`" />
          </v-tab-item>

          <v-tab ripple v-if="$deal.isAllowed('atLeastAdvisor')">{{ $t('labels.logs') }}</v-tab>
          <v-tab-item class="mt-4" v-if="$deal.isAllowed('atLeastAdvisor')">
            <v-tabs v-model="logTab" slider-color="grey darken-1">
              <v-tab ripple>{{ $t('labels.deal') }}</v-tab>
              <v-tab-item class="mt-4">
                <VDealLogbook :entity-id="boardItem.entity.id" :key="`logbook-${boardItem.entity.id}`" />
              </v-tab-item>
              <v-tab ripple>{{ $t('labels.partners') }}</v-tab>
              <v-tab-item class="mt-4">
                <partner-files :deal-id="boardItem.entity.id" />
              </v-tab-item>
            </v-tabs>
          </v-tab-item>

          <v-tab ripple v-if="$deal.isAllowed('atLeastAdvisor')">
            {{ $t('labels.transitions') }}
            <span v-if="hasTransitionWarning">
              <v-icon small class="ml-2" v-if="hasTransitionWarning">{{ $vuetify.icons.values.warning }}</v-icon>
            </span>
          </v-tab>

          <v-tab-item class="mt-4" v-if="$deal.isAllowed('atLeastAdvisor')">
            <VDealTransitions :key="`transistions-${boardItem.entity.id}`" />
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <router-view></router-view>
  </v-container>
  <v-loading v-else />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { AppTitleBar, VWidget, VLoading } from '@argon/app/components'
import { NAMESPACE as BOARD_NAMESPACE } from '@argon/evo/boards/store'
import { StateStepper } from '@argon/evo/entities/components'
import entityPerimeter from '@argon/evo/entities/perimeters'
import { CardMixin } from '@argon/evo/entities/mixins'
import { Modal } from '@argon/app/mixins'
import { VDealLogbook } from '../../logbook/deals/components'
import { HomeDealOverview, HomeDealGeneral, VDealTransitions, PartnerFiles } from '../components'
import { NAMESPACE as DEAL_NAMESPACE } from '../store'
import dealPerimeter from '../perimeters'

export default {
  name: 'HomeDealPageWidget',
  components: {
    HomeDealOverview,
    HomeDealGeneral,
    VDealLogbook,
    VDealTransitions,
    VWidget,
    AppTitleBar,
    StateStepper,
    PartnerFiles,
    VLoading
  },
  perimeters: [entityPerimeter, dealPerimeter],
  mixins: [CardMixin, Modal],
  props: {
    entityId: { type: [Number, String], required: true },
    boardRef: { type: String, required: true }
  },
  data() {
    return {
      activeTab: null,
      logTab: null,
      include: 'broker,firm,advisor,clients',
      returnPath: { name: 'tableView' }
    }
  },
  computed: {
    ...mapState(BOARD_NAMESPACE, ['board']),
    readOnly() {
      return !this.$deal.isAllowed('atLeastAdvisor')
    }
  },
  methods: {
    ...mapActions(BOARD_NAMESPACE, ['getBoard']),
    ...mapActions(DEAL_NAMESPACE, ['clearDealClients'])
  },
  destroyed() {
    this.clearDealClients()
  }
}
</script>

<style scoped>
.tools__area {
  min-height: 200px;
}
</style>
